import { type PropsWithChildren, type ReactNode } from "react";

import * as S from "./InputWrapper.styled";

export type InputWrapperProps = PropsWithChildren<{
  alert?: ReactNode;
  gap?: string;
}>;

function InputWrapper(props: InputWrapperProps) {
  const { alert, gap, children } = props;

  return (
    <S.Container $gap={gap}>
      {children}
      {alert && alert}
    </S.Container>
  );
}

export default InputWrapper;
